export const GET_TERMS_DLG = "GET_TERMS_DLG";
export const GET_TERMS_DLG_SUCCESS = "GET_TERMS_DLG_SUCCESS";
export const GET_TERMS_DLG_ERROR = "GET_TERMS_DLG_ERROR";
export const GET_TERMS_DLG_ERROR_MSG =
  "Unable to fetch the terms of use, please try again.";
export const SUBMIT_FEEDBACK_REQUEST = "SUBMIT_FEEDBACK_REQUEST";
export const SUBMIT_FEEDBACK_SUCCESS = "SUBMIT_FEEDBACK_SUCCESS";
export const SUBMIT_FEEDBACK_ERROR = "SUBMIT_FEEDBACK_ERROR";
export const SUBMIT_FEEDBACK_ERROR_MSG =
  "Unexpected error occurred. Please refresh and try again.";
export const SUBMIT_FEEDBACK_SUCCESS_MSG = "Feedback submitted successfully";
export const RESET_FEEDBACK = "RESET_FEEDBACK";
